import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { CompanyProvider } from './context/CompanyContext';
import { ServiceProvider } from './context/ServiceContext';
import { AuthProvider } from './context/AuthContext';
import { NotifProvider } from './context/NotifContext';
import { getUser } from './services/api';
import Login from './pages/Login';
import Onboarding from './pages/Onboarding';
import Dashboard from './pages/Dashboard';
import Leads from './pages/Leads';
import Team from './pages/Team';
import Finance from './pages/Finance';
import Analytics from './pages/Analytics';
import CalendarPage from './pages/Calendar';
import Projects from './pages/Projects';
import Settings from './pages/Settings';
import EmployeeDashboard from './pages/EmployeeDashboard';
import './index.css';

function Guard({ children, employeeOnly }) {
  const user = getUser();
  if (!user) return <Navigate to="/login" replace />;
  if (employeeOnly && user.role !== 'User') return <Navigate to="/dashboard" replace />;
  if (!employeeOnly && user.role === 'User') return <Navigate to="/employee" replace />;
  return children;
}

export default function App() {
  return (
    <ThemeProvider>
      <CompanyProvider>
        <ServiceProvider>
          <AuthProvider>
            <NotifProvider>
              <BrowserRouter>
                <Routes>
                  <Route path="/login"      element={<Login />} />
                  <Route path="/onboarding" element={<Guard><Onboarding /></Guard>} />
                  <Route path="/dashboard"  element={<Guard><Dashboard /></Guard>} />
                  <Route path="/leads"      element={<Guard><Leads /></Guard>} />
                  <Route path="/team"       element={<Guard><Team /></Guard>} />
                  <Route path="/finance"    element={<Guard><Finance /></Guard>} />
                  <Route path="/analytics"  element={<Guard><Analytics /></Guard>} />
                  <Route path="/calendar"   element={<Guard><CalendarPage /></Guard>} />
                  <Route path="/projects"   element={<Guard><Projects /></Guard>} />
                  <Route path="/settings"   element={<Guard><Settings /></Guard>} />
                  <Route path="/employee"   element={<Guard employeeOnly><EmployeeDashboard /></Guard>} />
                  <Route path="*"           element={<Navigate to="/login" replace />} />
                </Routes>
              </BrowserRouter>
            </NotifProvider>
          </AuthProvider>
        </ServiceProvider>
      </CompanyProvider>
    </ThemeProvider>
  );
}
